import { addNewPinnedItemModalId } from '@/services/domain/pinnedContact/types'
import { useWrapper } from '@/composition/modal'

export const openAddNewPinnedItemModal = () => useWrapper(addNewPinnedItemModalId).open()
